import {GlobalVariables} from "../GlobalVariables";

export default class SingleMovie {

	static init() {
		const movie = document.querySelector('.movie-single-player .movie');
		const chapters = document.querySelectorAll('[data-movie-seek]');
		if (!movie) {
			return;
		}

		// Lien vers un moment précis (?t=55, utilisé par les "moments clés" Google) :
		// la vidéo démarrera à ce temps au lancement
		const start = parseInt(new URLSearchParams(window.location.search).get('t'), 10);
		if (start > 0) {
			movie.dataset.seek = start;
		}

		const slider = document.querySelector('.movie-single-chapters-slider');
		if (slider) {
			const parent = slider.closest('.movie-single-chapters');
			new Swiper(slider, {
				slidesPerView: 'auto',
				spaceBetween: 28,
				grabCursor: true,
				navigation: {
					nextEl: parent.querySelector('.swiper-btn-next'),
					prevEl: parent.querySelector('.swiper-btn-prev')
				}
			});
		}

		chapters.forEach((chapter) => {
			chapter.addEventListener('click', () => {
				chapters.forEach(item => item.classList.remove('active'));
				chapter.classList.add('active');

				// BlockMovie se charge de lancer le lecteur puis de se positionner au bon temps
				movie.dispatchEvent(new CustomEvent('movie-seek', {
					detail: {seconds: Number(chapter.dataset.movieSeek)}
				}));

				const offset = -document.querySelector('header')?.offsetHeight || 0;
				if (GlobalVariables.lenis) {
					GlobalVariables.lenis.scrollTo(movie, {
						offset: offset,
						duration: 1,
						easing: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
					});
				} else {
					window.scrollTo({top: movie.getBoundingClientRect().top + window.scrollY + offset, behavior: 'smooth'});
				}
			});
		});
	}

}
